import { render, staticRenderFns } from "./BotResults.vue?vue&type=template&id=e61be986&"
import script from "./BotResults.vue?vue&type=script&lang=js&"
export * from "./BotResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports